import React from 'react'
import { ArrowRightIcon, TreePalmIcon } from '@phosphor-icons/react'
import DynamicProductCard from '@components/productcards/DynamicProductCard'
import LinkButton from '@components/common/LinkButton'

const EmptyBag = () => {
    let recentlyViewed = [];
    
    if (typeof window !== 'undefined') {
        recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewed")) || [];
    }
    
	return (
		<React.Fragment>
			<section className='flex flex-col w-full'>
				<div className='text-center py-8'>
					<TreePalmIcon size={32} weight='light' className='mx-auto' />
					<h2 className='m-1'>Your bag is empty</h2>
					<h4>Let's find your new favorite things!</h4>
				</div>

				<div className='space-y-8 text-md text-center mx-auto mt-10'>
					<LinkButton
						className={'underline-on-hover'}
						label={"Shop All Products"}
						ariaLabel='Shop All Products'
						icon={<ArrowRightIcon size={20} weight="light" />}
						
						to="/collections/all"
					/>
					<LinkButton
						className={'underline-on-hover'}
						label={"Shop New Arrivals"}
						ariaLabel='Shop New Arrivals'
						icon={<ArrowRightIcon size={20} weight="light" />}
						
						to="/collections/new-arrivals"
					/>
					<LinkButton
						className={'underline-on-hover'}
						label={"Shop Best Sellers"}
						ariaLabel='Shop Best Sellers'
						icon={<ArrowRightIcon size={20} weight="light" />}
						
						to="/collections/bestsellers"
					/>
				</div>

				<div className='space-y-1 px-4 pb-4 flex-1 content-end'>
					<p className='text-[14px]'>RECENTLY VIEWED</p>
					<div className='flex flex-nowrap gap-x-4'>
						{recentlyViewed.slice(0, 3).map((item, index) => {
							return (
								<DynamicProductCard
									data={item}
									style="compact"
									cardOptions='no-tag no-wishlist no-buttons'
									cardStyles='h-full'
									key={`recent-viewed-${index}`}
									width={104}
									height={120}
								/>
							);
						})}
					</div>
				</div>
			</section>
		</React.Fragment>
	)
}

export default EmptyBag